
  jQuery(document).ready(function($){
    $('.customslider').slick({
      dots: false,               // Shows dots for navigation
      infinite: true,           // Infinite scroll
      speed: 500,               // Transition speed
      slidesToShow: 1,          // Show one slide at a time
      slidesToScroll: 1,        // Scroll one slide at a time
      prevArrow: "<button type='button' class='slick-prev pull-left'></button>",
      nextArrow: "<button type='button' class='slick-next pull-right'></button>",
      autoplay: true,           // Auto-slide
      autoplaySpeed: 2000       // Slide interval
    });
  });

